import { Component, Inject, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, Validators } from '@angular/forms';
import { DatabaseService } from 'src/app/_services/database.service';
import { CustomEventsService } from 'src/app/_services/custom-events.service';

@Component({
  selector: 'app-add-remark-model',
  templateUrl: './add-remark.component.html'
})
export class LeadAddRemarkModelComponent implements OnInit {

  constructor(public events:CustomEventsService,public db:DatabaseService,@Inject(MAT_DIALOG_DATA) public data: any,private _location: Location) { }

  ngOnInit() {
    this.formsInit(this.data);
  }

  form: FormGroup;
  formsInit(data:any) {
    this.form = this.db.formBuilder.group({
      remark: [data.remark ? data.remark : null ],
      customer_id: [data.basicDetail.id ? data.basicDetail.id : null ,[Validators.required]],
    })
    console.log(this.form.value);

  }
  backClicked() {
    this._location.back();
  }

  onSubmit(){
    if(this.form.invalid){
      this.form.markAllAsTouched()
      return;
    }
    let reqData = this.form.value
    this.db.presentLoader();
    this.db.postReq(reqData,'dis_network/add_logs').subscribe(resp=>{
      this.db.dismissLoader();
      if(resp['status'] == 'success'){
        this.db.successAlert(resp['status'],resp['message']);
        this.db.matdialog.closeAll();
        this.events.publish('refresh-lead-detail',{});
      }else{
        if(resp['message']=='Invalid token'){
          this.db.sessionExpire();
          return;
        }
        this.db.presentAlert(resp['status'],resp['message'])
      }
    },err=>{
      this.db.errHandler(err);
      this.db.errDismissLoader();
    })
    
  }
  
}
